import { render, staticRenderFns } from "./LookupMailbox.vue?vue&type=template&id=69dcbbe9"
import script from "./LookupMailbox.vue?vue&type=script&lang=ts"
export * from "./LookupMailbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports